// Global VR session idle-reaper. Lives in a top-level always-mounted
// component (RenderOnAuthenticated) and periodically scans localStorage
// for in-flight sessions that have been idle longer than IDLE_THRESHOLD_MS.
// When it finds one, it fires a sendBeacon complete and clears the entry.
//
// Why this exists: useMatterportAnalytics' per-tour idle timer (30 min)
// only runs while the hook is mounted. The moment the user navigates away
// from the tour page, the component unmounts and clearTimeout kills the
// timer — leaving any started-but-not-completed session sitting "Active"
// in the DB forever. This reaper survives those navigations because it
// runs from RenderOnAuthenticated, which is mounted for the whole logged-
// in session.

import { useEffect } from "react";
import { recoverOrphanSessions } from "./useMatterportAnalytics";

const IDLE_THRESHOLD_MS = 5 * 60 * 1000;
const SCAN_INTERVAL_MS = 60 * 1000;

export const useGlobalSessionReaper = (enabled: boolean) => {
  useEffect(() => {
    if (!enabled) return undefined;
    // Initial scan on mount catches orphans from a prior page load / crash.
    recoverOrphanSessions(IDLE_THRESHOLD_MS);
    const timer = setInterval(() => {
      recoverOrphanSessions(IDLE_THRESHOLD_MS);
    }, SCAN_INTERVAL_MS);
    return () => clearInterval(timer);
  }, [enabled]);
};
